import { Component, OnInit } from '@angular/core';

import {CursoService} from "../../servicios/curso.service"
import { cursoI } from "../../shared/models/curso.interface";
import { Observable } from 'rxjs';

//temporal para pruebas
import { AuthService } from "../../servicios/auth.service";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public cursos$:Observable<cursoI[]>

  constructor(private cursoSvc:CursoService, public svc:AuthService)
  {

  }
 ngOnInit()
 {
  this.cursos$ = this.cursoSvc.getAllCursos();
  
   
 
 }
}
